import React from 'react';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import {DateRange as Range} from 'react-date-range';
import {noop} from '@ultradent/utilities/Functions';
import {array, arrayOf, bool, instanceOf, number, oneOf, shape, string} from 'prop-types';

// note - default styles can be override by including classNames
/*
@media (max-width: 752px) {
    .rdrDefinedRangesWrapper {
        display: none;
    }

        // force calendar to fit it's container for mobile only
    .rdrDateRangeWrapper,
    .rdrCalendarWrapper,
    .rdrDateRangeWrapper,
    .rdrMonths,
    .rdrMonth {
        width: 100%;
    }
}
*/

const PickerDefaults = {
    rangeColors: ['#2f80ed']
};

const DateRange = ( {
                              ranges,
                              pickerOptions = {},
                              onChange = noop,
                              className = ''
} ) => {
    const options = {
        ...PickerDefaults,
        ...pickerOptions
    };

    return (
        <Range
            className={className}
            {...options}
            ranges={ranges}
            onChange={onChange}
        />
    )
}

DateRange.propTypes = {
    ranges: arrayOf( shape( {
        startDate: instanceOf( Date ),
        endDate: instanceOf( Date ),
        key: string
    } ) ).isRequired,
    pickerOptions: shape({
        months: number,
        direction: oneOf( ['horizontal', 'vertical'] ),
        editableDateInputs: bool,
        inputRanges: array,
        rangeColors: arrayOf(string),
        maxDate: instanceOf( Date ),
        minDate: instanceOf( Date )
    })
};

export default DateRange;

